import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  url = this.api.url;
  pContent: any;
  fameList: any;
  constructor(private api: ApiService, private route: ActivatedRoute, private el: ElementRef) { }

  ngOnInit(): void {
    this.GetfameDetailed(this.route.snapshot.paramMap.get('id'));
    this.GetMTaxonomy();
    window.onmousewheel = (e) => {
      const ev = e || window.event;
    };

    this.el.nativeElement.querySelector('#scrollX')
      .addEventListener('mousewheel', (e: any) => {
          e = e || window.event;
          const delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
          this.el.nativeElement.querySelector('#scrollX').scrollLeft -= (delta * 40);
          e.preventDefault();
      }
    );
  }
  GetfameDetailed(id: any) {
    this.api.GetfameDetailed(id).subscribe(
      data => this.pContent = data
    )
  }
  GetMTaxonomy() {
    this.api.GetMTaxonomy('renwunianfen').subscribe(
      data => {
        this.api.GetfameList(data[0].taxonomyId, 1, 6).subscribe(
          fData => this.fameList = fData.halloffameList
        );
      }
    )
  }
}
